/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TGetSpecialistsCatalogModel,
  IGetSpecialistsCatalogRequest,
  IMappers,
  IGetSpecialistsCatalogResponse,
  IGetSpecialistsCatalogResponseError,
  TGetSpecialistsCatalogResponse,
} from './types';

const defaultConfig: TGetSpecialistsCatalogModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'demand',
  pathApi: '/v1/get-specialists-catalog/',
  hostType: 'api',
} as TGetSpecialistsCatalogModel;

function createGetSpecialistsCatalogModel(parameters: IGetSpecialistsCatalogRequest): TGetSpecialistsCatalogModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetSpecialistsCatalogOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IGetSpecialistsCatalogRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchGetSpecialistsCatalog<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IGetSpecialistsCatalogOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TGetSpecialistsCatalogResponse
> {
  const { response, statusCode } = await httpApi.fetch(createGetSpecialistsCatalogModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetSpecialistsCatalogResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IGetSpecialistsCatalogResponseError);
    }
  }

  return { response, statusCode } as TGetSpecialistsCatalogResponse;
}

export { defaultConfig, createGetSpecialistsCatalogModel, fetchGetSpecialistsCatalog };
